import React from 'react'
import { Breadcrumbs, Link } from '@mui/material'

const SetupBreadcrumbs = ({ history, setupId, activeView }) => {
  let setupsLabel = 'All Setups'
  if (activeView === 'active') setupsLabel = 'Active Setups'
  // if (activeView === 'aboveThreshold') setupsLabel = 'Above Threshold'
  return (
    <Breadcrumbs
      separator="›"
      aria-label="breadcrumb"
      style={{
        padding: '8px',
        display: 'flex',
        justifyContent: 'center',
        color: '#368ED8',
      }}
    >
      <Link
        underline="hover"
        color="inherit"
        onClick={() => history.push('/monitoring/client')}
        style={{ cursor: 'pointer', color: '#368ED8' }}
      >
        {setupsLabel}
      </Link>

      {setupId && (
        <Link
          underline="hover"
          color="inherit"
          onClick={() => history.push(`/monitoring/client/${setupId}`)}
          style={{ cursor: 'pointer', color: '#368ED8' }}
        >
          {setupId}
        </Link>
      )}
    </Breadcrumbs>
  )
}

export default SetupBreadcrumbs
